// extracted by mini-css-extract-plugin
export default {"label":"Search_label__i4Vfd","input":"Search_input__hE1yV"};